import React, { useEffect, useState } from 'react'
import { Icon } from '@iconify/react'

const BoxButton = ({ box, classes, handleCategoryClick, isOpen }) => {
  const [selectedIndex, setSelectedIndex] = useState(null) // State to track the selected index

  useEffect(() => {
    handleClick(0)
  }, [])

  const handleClick = index => {
    setSelectedIndex(index) // Update the selected index
    handleCategoryClick(index) // Call the passed handler
  }

  return (
    <div className={classes.fixedButtonContainer} id="editor-drag-drop-menu">
      {box.map((item, index) => (
        <div
          className={`${classes.fixedButton} ${
            isOpen === true
              ? selectedIndex === index
                ? classes.active
                : ''
              : null
          }`} // Add the active class if selected
          onClick={() => handleClick(index)}
          key={index}
        >
          <div className={classes.iconContainer}>
            <Icon width="24" height="24" icon={item.icon} />
            <span className={classes.label}>{item.category}</span>
          </div>
        </div>
      ))}
    </div>
  )
}

export default BoxButton
